class Accordion {
	constructor(el,opt){
		this.el = el;
		this.event();
	}
	event(){
        if (window.matchMedia('(max-width: 979px)').matches) {
            $(function(){
                //クリックで動く

                const a = document.querySelector(".acc-event")
                const b = document.querySelector(".salon-content")

                $('.acc-event').click(function(){
                    if (window.matchMedia( "(min-width: 400px)" ).matches) {
                        return false;
                    } else {
                        $(this).toggleClass('active');
                        $(this).next('.salon-content').slideToggle();
                    }

                });
            });

        }

	}
}

